import { Trainee } from '@/generated';
import { traineeApi } from '@/generated/clients';
import { CardActions, Paper, Tooltip } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useEffect, useState } from 'react';
import { TraineeCard } from './TraineeCard';
import HistoryIcon from '@mui/icons-material/History';
import { useNavigate } from 'react-router-dom';
import { ContentPaste, Style } from '@mui/icons-material';
import { DefaultContainer } from '@/components/DefaultContainer';
import { pathMap } from '@/navigation/paths';

export const Trainees = () => {
  const [trainees, setTrainees] = useState<Trainee[]>();
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      setTrainees(await traineeApi.traineeManagementListTrainees());
    };
    load();
  }, []);

  return (
    <DefaultContainer>
      <Paper sx={{ my: 1, zIndex: 1, padding: 1, position: 'sticky', top: { xs: 60, sm: 65 } }}></Paper>
      <Grid container spacing={1}>
        {trainees?.map((t) => {
          return (
            <TraineeCard trainee={t} timeout={1000}>
              <CardActions sx={{ justifyContent: 'flex-end', alignSelf: 'flex-end', flex: 0.1 }}>
                <Tooltip title={`View ${t.name}'s training history`}>
                  <HistoryIcon onClick={() => navigate(`/history/${t.userId}`)} sx={{ cursor: 'pointer' }} />
                </Tooltip>
                <Tooltip title={`View ${t.name}'s sets. (Not all sets may be visible due to your role's restrictions.)`}>
                  <Style sx={{ cursor: 'pointer' }} onClick={() => navigate(`${pathMap.Decks}/${t.userId}`)} />
                </Tooltip>
                <Tooltip sx={{ cursor: 'pointer' }} onClick={() => navigate(`/trainee-plan-assignment/${t.userId}`)} title={`Assign Training Plans`}>
                  <ContentPaste />
                </Tooltip>
              </CardActions>
            </TraineeCard>
          );
        })}
      </Grid>
    </DefaultContainer>
  );
};
